import React from 'react';
import SiteDocCategory from './SiteDocCategory';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';

export default function SiteDocsContainer({ siteDocsData, onSelectDoc, viewDoc, downloadDoc, downloadAll, sectionName, sectionIcon }) {
    let docCategories = !siteDocsData.loading && siteDocsData.siteDocs && siteDocsData.siteDocs
        //.filter(projectDocType => projectDocType.id !== 1)/* Filter out Active Site Maps */
        .map(category => <SiteDocCategory
            key={category.key}
            category={category}
            onSelectDoc={onSelectDoc}
            viewDoc={viewDoc}
            downloadDoc={downloadDoc}
            downloadAll={downloadAll} />); 

    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
        <div className="projectDocsContainer">
            {docCategories}
        </div>
    </>);
}